import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { IncentiveModel } from '../models/incentive.model';

@Component({
    selector: 'incentive-edit-component',
    templateUrl: './incentive-edit.component.html',
    styleUrls: ['./incentive-edit.component.scss'],
    providers: [MessageService]
})

export class IncentiveEditComponent implements OnInit, AfterViewInit {
    @Input() incentiveModelInput!: IncentiveModel;
    @Output() backLinkClick = new EventEmitter();

    updateParentBackLinkClicked() {
        this.backLinkClick.emit();
    }
    ngOnInit(): void {
    }
    ngAfterViewInit(): void {
    }
}
